import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-load-more-simple',
  templateUrl: './load-more-simple.component.html',
  styleUrls: ['../load-more/load-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class LoadMoreSimpleComponent {
  @Output() public loadMore = new EventEmitter();
}
